module.exports = __webpack_public_path__ + "img/jackpot.94c67175.png";